import { render, staticRenderFns } from "./app-register.vue?vue&type=template&id=86a46f50&scoped=true"
import script from "./app-register.vue?vue&type=script&lang=js"
export * from "./app-register.vue?vue&type=script&lang=js"
import style0 from "./app-register.vue?vue&type=style&index=0&id=86a46f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a46f50",
  null
  
)

export default component.exports